// src/api/services/uploadService.ts
import api from "../axios";

export interface PresignedResponse {
  uuid: string;
  presignedUrl: string;
}

export function getPresignedUpload(fileName: string) {
  return api.get<PresignedResponse>(`/uploads/presigned`, {
    params: { fileName },
  });
}

export function confirmUpload(uploadUuid: string) {
  return api.post(`/uploads/${encodeURIComponent(uploadUuid)}/complete`);
}